/**
 * Toolbar component themeable props.
 */
import { stringLiteralArray } from "../utils"

export default {
  appearances: stringLiteralArray(["default"])
}
